// =====================================
//
//   付款結果 Controller
//   Author: Wayne
//   createtime: 2016 / 08 / 24
//
// =====================================

window.InifECMobileApp.controller("PaymentPointController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'UserService', 'OrderService', 'PointService',
	function($scope, $state, $timeout, $rootScope, $stateParams, UserService, OrderService, PointService) {

        var getOrderInfo = function() {

            OrderService.getOrderInfo($scope.orderid).then(function(result) {
                
                if(result) {
                    $scope.order = result;
                    
                    // 如果不是審查合格狀態則踢掉
                    if($scope.order.orderstatus != 250 && $scope.order.orderstatus != 300){
                        $scope.isLoading = false;
                        $scope.isStatusError = true;
                    } else {
                        pay();
                    }

                } else {
                    $scope.isLoading = false;
                    $scope.isError = true;
                }
    

            }, function(error) {

                if(error && (error.code == 'error.rscNotExist' || error.code == 'error.privilege.noReadable')) {
                    $scope.isOrderNotExist = true;
                } else {
                    $scope.isError = true;
                }

                $scope.isLoading = false;
            });
        };

        var pay = function() {

            OrderService.payPointsForOrder($scope.orderid).then(function(result) {
                if(result) {
                    $scope.isPaySuccess = true;

                    $rootScope.$broadcast('ORDER_STATUS_UPDATE', {
                        orderid: $scope.orderid,
                        orderstatus: 400,
                    });

                } else {
                    $scope.isError = true;
                }

                $scope.isLoading = false;
            }, function(error) {

                $scope.isError = true;
                $scope.isLoading = false;
            });
        };

        var init = function() {
                
            $scope.isLoading = true;

            UserService.getUserInfo().then(function(result) {
                getOrderInfo();
            }, function(error) {
                $scope.isNoLogin = true;
                $scope.isLoading = false;
            });
        }

	    //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        $scope.orderid = $stateParams.orderid;
        $scope.order;
        $scope.isLoading = false;
        $scope.isStatusError = false;
        $scope.isError = false;
        $scope.isOrderNotExist = false;
        $scope.isPaySuccess = false;
        $scope.isNoLogin = false;
        $scope.pointsBalanceRec = PointService.lastPoint;

        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        init();
	}
]);